module.exports = __webpack_public_path__ + "img/plus_white_icon.1afad10c.svg";